import { render, staticRenderFns } from "./JobHistory.vue?vue&type=template&id=10f53be0&scoped=true&"
import script from "./JobHistory.vue?vue&type=script&lang=ts&"
export * from "./JobHistory.vue?vue&type=script&lang=ts&"
import style0 from "./JobHistory.vue?vue&type=style&index=0&id=10f53be0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f53be0",
  null
  
)

export default component.exports